// Dependencies
import axios, { AxiosInstance } from 'axios'
import _ from 'lodash'

// Types
import { Headers, Response, Config, Request } from './types'

export default class ApiController {
  protected baseURL: string
  protected timeout: number
  protected namespace: string
  protected headers: Headers

  protected axios: AxiosInstance

  constructor({ baseURL, namespace, timeout, headers }: Config) {
    this.baseURL = baseURL
    this.namespace = namespace
    this.timeout = timeout
    this.headers = headers

    this.axios = axios.create({
      baseURL: this.baseURL,
      timeout: this.timeout,
      headers: this.headers,
    })
  }

  public async request({
    endpoint: requestArgs,
    namespace = undefined,
    query = undefined,
    args = undefined,
  }: Request): Promise<Response> {
    let response: Response = {}

    requestArgs = {
      ...requestArgs,
      ...{ url: this.getRequestURL(requestArgs.url, namespace, query) },
    }

    if (!_.isEmpty(args)) {
      requestArgs = { ...requestArgs, ...args }
    }

    try {
      response = await (await this.axios.request(requestArgs)).data
    } catch (error) {
      response.errors = error
      console.error(error)
    }

    return response
  }

  private getRequestURL = (
    url: string,
    namespace: string | undefined,
    query: string | number | undefined,
  ) =>
    (!_.isUndefined(namespace) ? namespace : this.namespace) +
    url +
    (!_.isUndefined(query) ? `/${query}` : '')
}
